<template>
  <div class="table table-hover">
    <div class="thead">
      <div v-if="value.chart" class="img-thumbnail mb-4 p-2 text-center overflow-auto">
        <img
          :src="'data:image/png;base64,' + value.chart"
        />
      </div>
      <div class="row" v-if="!blockLayout">
        <template v-for="c in value.columns">
          <template v-if="isInteresting(c)">
            <div class="col">{{ c }}</div>
          </template>
        </template>
      </div>
    </div>
    <div class="tbody">
      <div class="row" :class="rowClass && rowClass(value, row)" v-for="row in value.records">
        <template v-for="c in value.columns">
          <template v-if="isInteresting(c)">
            <div class="col-4 font-weight-bold" v-if="blockLayout">
              {{ c }}
            </div>
            <div :class="blockLayout ? 'col-8' : 'col'">
              {{ row[c] }}
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object
    },

    blockLayout: {
      type: Boolean,
      default: false
    },

    rowClass: {
      type: Function,
      default: undefined
    }
  },

  methods: {
    isInteresting(col) {
      return true;
    },
  }
};
</script>
